import { render } from "./modalCompanyComponent.vue?vue&type=template&id=72fd8f64&scoped=true"
import script from "./modalCompanyComponent.vue?vue&type=script&lang=js"
export * from "./modalCompanyComponent.vue?vue&type=script&lang=js"

import "./modalCompanyComponent.vue?vue&type=style&index=0&id=72fd8f64&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72fd8f64"]])

export default __exports__